<template>
  <div id="alert-modal" v-if="alertId !== ''">
    <div v-if="alertFull" class="relative">
      <table id="print-area" class="stripes first-dark container">
        <thead>
          Alert Details
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>{{ alertFull.id }}</td>
          </tr>
          <tr>
            <td>title</td>
            <td>{{ alertFull.title }}</td>
          </tr>
          <tr>
            <td>date</td>
            <td>{{ alertFull.date }}</td>
          </tr>
          <tr>
            <td>type</td>
            <td>{{ alertFull.type }}</td>
          </tr>
          <tr>
            <td>description</td>
            <td>
              <div v-html="alertFull.message"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="loading-full overflow-hidden">
      <BaseSmallSpinner />
    </div>
  </div>
</template>
<script>
import { getAlert as getAlertApi } from "@/api/masterAdmin/AlertsService.js";
export default {
  name: "AlertModal",
  props: {
    alertId: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      alertFull: null,
      isOpenModal: this.value,
      loading: true
    };
  },
  mounted() {
    this.getAlert();
    window.addEventListener("keypress", this.closeKey);
  },
  computed: {
    isOpen() {
      return this.value;
    }
  },
  watch: {
    isOpenModal(val) {
      this.$emit("input", val);
      if (!val) {
        this.$emit("closedAlert");
      }
    },
    value(val) {
      this.isOpenModal = val;
    },
    alertId(val) {
      if (val != "") {
        this.alertFull = null;
        this.getAlert(val);
      }
    }
  },
  methods: {
    closeKey(event) {
      if (event.keyCode === 113) {
        this.$emit("closedAlert");
      }
    },
    close() {
      this.$emit("closedAlert");
    },
    async getAlert() {
      console.log(this.alertId);
      if (this.alertId == "") {
        return;
      }
      this.alertFull = await getAlertApi(this.alertId);
      this.loading = false;
    },
    print() {
      window.print();
    }
  },
  beforeDestroy() {
    window.removeEventListener("keypress", this.closeKey);
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/generic-variables.scss";
.stripes tr:nth-child(odd) {
  background-color: $tableBackgroundAlternative;
}
@media print {
  table {
    width: 100%;
  }
}
#alert-modal {
  width: 600px;
  max-width: 100%;
}
table tr td {
  @apply p-2;
}
</style>
<style>
@media print {
  body * {
    visibility: hidden;
  }
  #print-area,
  #print-area * {
    visibility: visible;
  }
  #print-btn-tr {
    display: none;
  }
}
</style>
